import React, { useState, useEffect } from "react";
// material
import {
  Badge,
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Modal,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import DataTable from "react-data-table-component";
import Page from "src/components/Page";
import {
  fetchallcitylist,
  fetchchapterbyuser,
  getSuggestionListByCity,
  handleDownload
} from "src/utils/common";
import { CSVLink } from "react-csv";
import Select from "react-select";
import Label from "src/components/Label";
import { Add, EditSharp } from "@mui/icons-material";
import { notification } from "src/utils/messages";
import {
  deleteSuggestionAttachmentApi,
  updateSuggestionAnswer,
  uploadSuggestionChunkApi
} from "src/api/commonapi";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DatePicker from "@mui/lab/DatePicker";
import { useLocation } from "react-router-dom";
import CustomLoader from "src/commonComponents/CustomLoader";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Routes } from "src/constant/api_url";
import DownloadIcon from "@mui/icons-material/Download";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import Deletemodal from "./DeleteModal";
import normalizeSearch from "src/utils/normalizeSearch";

export function Suggestion() {
  const askDetailModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: 600,
    maxHeight: "90vh", // 🔥 IMPORTANT
    bgcolor: "#fff",
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    p: 2
  };

  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const location = useLocation();

  const [suggestion, setSuggestion] = useState([]);
  const [newSuggestionList, setNewSuggestionList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isAttachmentSubmitLoading, setIsAttachmentSubmitLoading] = useState(false);

  const [answerModal, setAnswerModal] = useState(false);
  const [attachmentsModal, setAttachmentsModal] = useState(false);
  const [attachmentsType, setAttachmentsType] = useState(0);
  const [suggestionAnswer, setSuggestionAnswer] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("0"); // default is "Open"
  const [suggestionID, setSuggestionID] = useState(null);
  const [files, setFiles] = useState([]);
  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });

  const allowedTypes = [
    // Extensions
    ".pdf",
    ".csv",
    ".doc",
    ".docx",
    ".dot",
    ".dotx",
    ".ppt",
    ".pptx",
    ".odt",
    ".rtf",
    ".txt",
    ".xlsx",
    ".xls",
    ".jpg",
    ".jpeg",
    ".png",
    ".gif",
    ".tiff",
    ".tif",
    ".webp",
    ".heif",
    ".heic",
    ".svg",
    ".ico",
    ".bmp",
    ".raw",
    ".psd",
    ".ai",
    ".mp4",
    ".avi",
    ".mkv",
    ".mov",
    ".wmv",
    ".flv",
    ".webm",
    ".mpeg",
    ".mpg",
    ".3gp",
    ".avchd",
    ".mp3",
    ".wav",
    ".aac",
    ".flac",
    ".ogg",
    ".m4a",
    ".wma",
    ".alac",
    ".aiff",
    ".opus",
    ".odp",
    ".ods"
  ];

  const [searchData, setSearchData] = useState({
    // if admin is login the search Type is 0 and if city Amb is login then their city id is search Type
    city_id:
      loginUser?.u_type == 0 ||
      (loginUser?.u_type == 2 && loginUser?.p_user_id == 1 && loginUser?.management_p != 0)
        ? location.state?.city || 0
        : loginUser?.city_id, // In City Data Get,
    chpt_id: 0,
    s_type: -1,
    s_status: -1,
    searchmember: "",
    startDate: null,
    endDate: null
  });

  const [chaptlist, setchaplist] = useState([]);
  useEffect(async () => {
    setchaplist(await fetchchapterbyuser(loginUser.city_id, loginUser.u_type));
  }, []);

  const SuggestionFor = [
    { label: "All", value: -1 },
    { label: "Application suggestion ", value: 0 },
    { label: "LVB Workflow Suggestion", value: 1 }
  ];
  const SuggestionStatus = [
    { label: "All", value: -1 },
    { label: "Open", value: 0 },
    { label: "Close", value: 1 }
  ];

  const expo_columns = [
    { label: "Chapter Name", key: "chpt_name" },
    { label: "Suggestion Given By", key: "m_name" },
    { label: "Suggestion", key: "suggestion" },
    { label: "Date", key: "date" },
    { label: "Suggestion Answer", key: "suggestion_ans" },
    { label: "Answer Date", key: "ans_date" },
    { label: "Suggestion For", key: "suggestion_for" },
    { label: "Suggestion Status", key: "suggestion_status" }
  ];

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row) => row.s_id,
      sortable: true,
      width: "100px"
    },
    {
      name: "Chapter Name",
      wrap: true,
      selector: (row) => row.chpt_name,
      width: "130px",
      sortable: true
    },
    {
      name: "Suggestion Given By",
      wrap: true,
      selector: (row) => (
        <div
          style={{
            cursor: "pointer",
            overflow: "visible",
            whiteSpace: "pre-line"
          }}
        >
          {row.m_name}
        </div>
      ),
      width: "170px",
      sortable: true
    },
    {
      name: "Suggestion For",
      wrap: true,
      width: "auto",
      selector: (row) => (
        <Label variant={"ghost"} color={row.s_type == 1 ? "success" : "info"}>
          {row.suggestion_for}
        </Label>
      )
    },
    {
      name: "Suggestion Date",
      wrap: true,
      width: "150px",
      selector: (row) => row.date,
      sortable: true
    },
    {
      name: "Answer Date",
      wrap: true,
      width: "120px",
      selector: (row) => (row.ans_date != null && row.ans_date != "" ? row.ans_date : "-"),
      sortable: true
    },
    {
      name: "Suggestion Status",
      wrap: true,
      width: "100px",
      selector: (row) => (
        <Label
          variant="ghost"
          color={row.s_status == 0 ? "success" : "error"}
          style={{
            marginBottom: "10px",
            display: "flex",
            fontSize: "12px",
            fontWeight: "normal"
          }}
        >
          {row.s_status == 0 ? "Open" : "Closed"}
        </Label>
      ),
      sortable: true
    },
    {
      name: "Give Answer",
      width: "150px",
      cell: (row) => (
        <>
          <Tooltip title="Add Answer">
            <IconButton
              onClick={(e) => {
                setAnswerModal(true);
                setSuggestionID(row);
              }}
            >
              {row.ans_date != null && row.ans_date !== "" ? (
                <EditSharp color="info" />
              ) : (
                <Add color="info" />
              )}
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  const ExpandableRow = ({ data }) => {
    return (
      <Box
        sx={{
          p: 1,
          my: 1,
          borderRadius: 2,
          bgcolor: "#f9fafb",
          border: "1px solid #e5e7eb"
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="subtitle2" sx={{ mb: 1, color: "#6b7280", fontWeight: 600 }}>
            💡 Suggestion
          </Typography>

          {data?.suggestion_attachments?.length > 0 && (
            <Box
              onClick={() => {
                setAttachmentsModal(true);
                setAttachmentsType(1);
                setSuggestionID(data);
              }}
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 1,
                px: 1,
                py: 0.5,
                borderRadius: 2,
                cursor: "pointer",
                backgroundColor: "#eef2ff",
                color: "#3730a3",
                border: "1px solid #e5e7eb",
                transition: "all 0.2s ease",
                "&:hover": {
                  backgroundColor: "#e5e7eb"
                }
              }}
            >
              <InsertDriveFileIcon sx={{ fontSize: 16, color: "#6b7280" }} />

              <Typography sx={{ fontSize: 13, fontWeight: 500 }}>Attachments</Typography>

              <Box
                sx={{
                  ml: 0.5,
                  px: 1,
                  borderRadius: "999px",
                  backgroundColor: "#e5e7eb",
                  fontSize: 12,
                  fontWeight: 500
                }}
              >
                {data.suggestion_attachments.length}
              </Box>
            </Box>
          )}
        </Stack>

        <Typography
          sx={{
            fontSize: 14,
            color: "#111827",
            mb: 1,
            lineHeight: 1.6
          }}
        >
          {data?.suggestion || "No suggestion provided"}
        </Typography>

        <Divider sx={{ my: 1 }} />

        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="subtitle2" sx={{ mb: 1, color: "#6b7280", fontWeight: 600 }}>
            📝 Answer
          </Typography>
          {data?.suggestion_ans_attachments?.length > 0 && (
            <Box
              onClick={() => {
                setAttachmentsModal(true);
                setAttachmentsType(2);
                setSuggestionID(data);
              }}
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 1,
                px: 1,
                py: 0.5,
                borderRadius: 2,
                cursor: "pointer",
                backgroundColor: "#eef2ff",
                color: "#3730a3",
                border: "1px solid #e5e7eb",
                transition: "all 0.2s ease",
                "&:hover": {
                  backgroundColor: "#e5e7eb"
                }
              }}
            >
              <InsertDriveFileIcon sx={{ fontSize: 16, color: "#6b7280" }} />

              <Typography sx={{ fontSize: 13, fontWeight: 500 }}>Attachments</Typography>

              <Box
                sx={{
                  ml: 0.5,
                  px: 1,
                  borderRadius: "999px",
                  backgroundColor: "#e5e7eb",
                  fontSize: 12,
                  fontWeight: 500
                }}
              >
                {data.suggestion_ans_attachments.length}
              </Box>
            </Box>
          )}
        </Stack>

        <Typography
          sx={{
            fontSize: 14,
            color: "#374151",
            lineHeight: 1.6,
            whiteSpace: "pre-line"
          }}
        >
          {data?.suggestion_ans || "No answer available"}
        </Typography>
      </Box>
    );
  };

  useEffect(() => {
    suggestionList();
  }, []);

  useEffect(() => {
    filterSuggestions();
  }, [suggestion, searchData]);

  const suggestionList = async () => {
    setIsLoading(true);
    let resp = await getSuggestionListByCity(searchData);
    setIsLoading(false);
    setSuggestion(resp);
  };

  const filterSuggestions = () => {
    let nSuggestion = [];

    nSuggestion =
      suggestion &&
      suggestion.filter((sug) => {
        const suggestionDate = sug.date ? new Date(sug.date) : null;
        const startDate = searchData.startDate ? new Date(searchData.startDate) : null;
        const endDate = searchData.endDate ? new Date(searchData.endDate) : null;

        let dateMatch = true;
        if (startDate && endDate && suggestionDate) {
          // Remove time from comparison
          suggestionDate.setHours(0, 0, 0, 0);
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(0, 0, 0, 0);
          dateMatch = suggestionDate >= startDate && suggestionDate <= endDate;
        }
        if (
          (sug.city_id == searchData.city_id || searchData.city_id == 0) &&
          (sug.c_id == searchData.chpt_id || searchData.chpt_id == 0) &&
          (sug.s_type == searchData.s_type || searchData.s_type == -1) &&
          (sug.s_status == searchData.s_status || searchData.s_status == -1) &&
          (sug.m_name.toLowerCase().includes(normalizeSearch(searchData.searchmember)) ||
            searchData.searchmember == "") &&
          dateMatch
        ) {
          return sug;
        }
      });

    setNewSuggestionList(nSuggestion);
  };

  const [citylist, setcitylist] = useState([]);

  const getallcitylist = async () => {
    setcitylist(await fetchallcitylist());
  };

  useEffect(async () => {
    getallcitylist();
  }, []);

  useEffect(() => {
    if (answerModal && suggestionID) {
      if (suggestionID.suggestion_ans && suggestionID.suggestion_ans.trim() !== "") {
        // If answer already exists, show existing answer
        setSuggestionAnswer(suggestionID.suggestion_ans);
      } else {
        // First time answering — show default message
        const defaultMessage = `Hi ${
          suggestionID.m_name
        }, we have received your message regarding ${
          suggestionID.s_type == 1 ? "LVB WORKFLOW" : " LVB APPLICATION"
        } Suggestion.\n\n`;
        setSuggestionAnswer(defaultMessage);
      }
      setSelectedStatus(String(suggestionID.s_status ?? "0"));
    }
  }, [answerModal, suggestionID]);

  const ClearSearchResult = async () => {
    setSearchData({
      city_id:
        loginUser?.u_type == 0 ||
        (loginUser?.u_type == 2 && loginUser?.p_user_id == 1 && loginUser?.management_p != 0)
          ? 0
          : loginUser?.city_id, // In City Data Get,
      chpt_id: 0,
      s_type: -1,
      s_status: -1,
      searchmember: "",
      startDate: null,
      endDate: null
    });
  };

  const handleFiles = (selectedFiles) => {
    const validFiles = [];

    Array.from(selectedFiles).forEach((file) => {
      const fileName = file.name.toLowerCase();

      const isValid = allowedTypes.some((ext) => fileName.endsWith(ext));

      if (isValid) {
        validFiles.push(file);
      } else {
        let notify = notification({
          type: "error",
          message: `❌ ${file.name} is not allowed`
        });
        notify();
      }
    });

    setFiles((prev) => [...prev, ...validFiles]);
  };

  const createChunks = (file, chunkSizeMB = 10) => {
    const chunks = [];
    const chunkSize = chunkSizeMB * 1024 * 1024;

    let start = 0;

    while (start < file.size) {
      chunks.push(file.slice(start, start + chunkSize));
      start += chunkSize;
    }

    return chunks;
  };

  const uploadSingleFile = async (file) => {
    const uploadId = crypto.randomUUID();
    const chunks = createChunks(file, 10);
    const totalChunks = chunks.length;

    for (let i = 0; i < totalChunks; i++) {
      const formData = new FormData();

      formData.append("uploadId", uploadId);
      formData.append("chunkIndex", i);
      formData.append("totalChunks", totalChunks);
      formData.append("fileName", file.name);
      formData.append("mimeType", file.type);
      formData.append("chunk", chunks[i]);

      let resp = await uploadSuggestionChunkApi(formData);

      if (resp?.status && resp?.data?.done) return resp?.data?.fileName;
    }
  };

  const suggestionAnswerHandler = async () => {
    setIsAttachmentSubmitLoading(true);

    if (!suggestionAnswer) {
      notification({
        type: "error",
        message: "Please Enter Answer."
      })();
      return;
    }

    const fileNamesChunk = [];

    const fileArray = Array.from(files);

    for (const file of fileArray) {
      const chunkFileName = await uploadSingleFile(file);

      fileNamesChunk.push(chunkFileName);
    }

    const res = await updateSuggestionAnswer({
      type: suggestionID.ans_date != null && suggestionID.ans_date != "" ? 1 : 0,
      s_status: parseInt(selectedStatus),
      suggestion_ans: suggestionAnswer,
      s_id: suggestionID?.s_id,
      m_id: suggestionID?.m_id,
      m_name: suggestionID?.m_name,
      suggestion_ans_attachments: fileNamesChunk
    });

    if (res.status == 1) {
      let notify = notification({
        type: res.status == 0 ? "error" : "success",
        message: res.message
      });
      notify();
      suggestionList(); // refresh data
      setFiles([]);
    }
    setAnswerModal(false);
    setSuggestionAnswer("");
    setIsAttachmentSubmitLoading(false);
  };

  const deleteSuggestionAttachment = async (id) => {
    const resp = await deleteSuggestionAttachmentApi(id);

    if (resp.status) {
      setDvisible({ mval: false, id: 0 });

      const updatedData = suggestion?.map((item) => {
        if (item?.s_id == suggestionID?.s_id) {
          return {
            ...item,
            suggestion_ans_attachments: item?.suggestion_ans_attachments?.filter(
              (attach) => attach?.s_a_id != id
            )
          };
        }
        return item;
      });

      setSuggestion(updatedData);
      setSuggestionID(updatedData?.find((item) => item?.s_id == suggestionID?.s_id));
    }

    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
  };

  return (
    <>
      <Deletemodal
        visible={dvisible}
        setVisible={setDvisible}
        deletefunc={deleteSuggestionAttachment}
      />
      <Page title="LVB Suggestion | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              LVB Suggestion
            </Typography>
          </Stack>

          <Card
            style={{
              padding: "25px"
            }}
          >
            <Grid container spacing={2} style={{ marginBottom: "20px" }}>
              <Grid item xs={3}>
                <Stack sx={{ marginBottom: "15px" }}>
                  <label>Select City</label>
                  <Select
                    menuPortalTarget={document.body}
                    isDisabled={
                      loginUser?.u_type == 1 ||
                      (loginUser?.u_type == 2 &&
                        loginUser?.p_user_id != 1 &&
                        loginUser?.management_p == 1)
                        ? true
                        : false
                    }
                    options={[
                      {
                        value: 0,
                        label: "All City"
                      },
                      ...citylist.map((city) => {
                        return {
                          label: city?.city_name,
                          value: city?.city_id
                        };
                      })
                    ]}
                    onChange={(e) => {
                      setSearchData({
                        ...searchData,
                        city_id: e.value,
                        chpt_id: 0
                      });
                    }}
                    value={
                      searchData.city_id == 0
                        ? {
                            value: 0,
                            label: "All City"
                          }
                        : citylist.map((city) => {
                            return (
                              searchData.city_id == city.city_id && {
                                value: city.city_id,
                                label: city.city_name
                              }
                            );
                          })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <label>Select Chapter</label>
                  <Select
                    name="chpt_id"
                    menuPortalTarget={document.body}
                    onChange={(e) => {
                      setSearchData({
                        ...searchData,
                        chpt_id: e.value
                      });
                    }}
                    options={[
                      {
                        value: 0,
                        label: "All Chapter"
                      },
                      ...(chaptlist &&
                        chaptlist
                          ?.map((chpt) => {
                            if (searchData?.city_id != 0) {
                              if (chpt?.city_id == searchData?.city_id) {
                                return {
                                  value: chpt.chpt_id,
                                  label: chpt.chpt_name
                                };
                              }
                            } else {
                              return {
                                value: chpt.chpt_id,
                                label: chpt.chpt_name
                              };
                            }
                          })
                          .filter((f) => f != undefined))
                    ]}
                    value={
                      searchData.chpt_id == 0
                        ? { value: 0, label: "All Chapter" }
                        : chaptlist &&
                          chaptlist.map((c) => {
                            if (c.chpt_id == searchData.chpt_id) {
                              return {
                                value: c.chpt_id,
                                label: c.chpt_name
                              };
                            }
                          })
                    }
                  />
                </Stack>
              </Grid>

              {loginUser?.u_type === 0 && (
                <Grid item xs={3}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <label>Suggestion For</label>
                    <Select
                      name="s_type"
                      menuPortalTarget={document.body}
                      onChange={(e) => {
                        setSearchData({
                          ...searchData,
                          s_type: e.value
                        });
                      }}
                      value={SuggestionFor.map((c) => {
                        if (c.value == searchData.s_type) {
                          return { value: c.value, label: c.label };
                        }
                      })}
                      options={SuggestionFor}
                    />
                  </Stack>
                </Grid>
              )}

              <Grid item xs={3}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <label>Suggestion Status</label>
                  <Select
                    name="s_status"
                    menuPortalTarget={document.body}
                    onChange={(e) => {
                      setSearchData({
                        ...searchData,
                        s_status: e.value
                      });
                    }}
                    value={SuggestionStatus.map((c) => {
                      if (c.value == searchData.s_status) {
                        return { value: c.value, label: c.label };
                      }
                    })}
                    options={SuggestionStatus}
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={0}>
                  <LocalizationProvider dateAdapter={AdapterDateFns} style={{ marginTop: "0px" }}>
                    <label>Select Suggestion Start Date</label>
                    <DatePicker
                      type="date"
                      name="s_date"
                      label="Start Date "
                      inputFormat="dd/MM/yyyy"
                      value={searchData.startDate != null ? searchData.startDate : null}
                      onChange={(newDate) => {
                        setSearchData({
                          ...searchData,
                          startDate: newDate
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          // onKeyDown={(e) => e.preventDefault()}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={0}>
                  <label>Select Suggestion End Date</label>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      type="date"
                      name="e_date"
                      label="End Date "
                      inputFormat="dd/MM/yyyy"
                      value={searchData.endDate != null ? searchData.endDate : null}
                      onChange={(newDate) => {
                        setSearchData({
                          ...searchData,
                          endDate: newDate
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          // onKeyDown={(e) => e.preventDefault()}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>

              <Grid item xs={4}>
                <Stack spacing={3}>
                  <label>Search Member</label>
                  <TextField
                    style={{ marginTop: "0px" }}
                    autoComplete="off"
                    type="text"
                    label="Search Member"
                    name="search"
                    size="small"
                    value={searchData?.searchmember ? searchData?.searchmember : ""}
                    onChange={(e) => {
                      setSearchData({
                        ...searchData,
                        searchmember: e.target.value
                      });
                    }}
                  />
                </Stack>
              </Grid>

              <Grid xs={1} item sx={{ display: "flex", justifyContent: "flex-end" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                  }}
                >
                  <Button variant="outlined" onClick={ClearSearchResult}>
                    Clear
                  </Button>
                </div>
              </Grid>
            </Grid>

            <>
              <Button className="btn btn-export">
                <CSVLink
                  data={newSuggestionList.map((item) => ({
                    chpt_name: item.chpt_name,
                    m_name: item.m_name,
                    suggestion: `"${(item.suggestion || "")
                      .replace(/"/g, '""')
                      .replace(/\n/g, " ")}"`,
                    date: item.date,
                    suggestion_ans: `"${(item.suggestion_ans || "")
                      .replace(/"/g, '""')
                      .replace(/\n/g, " ")}"`,
                    ans_date: item.ans_date,
                    suggestion_for: item.suggestion_for,
                    suggestion_status: item.s_status === 0 ? "Open" : "Closed"
                  }))}
                  headers={expo_columns}
                  filename={"Suggestion.csv"}
                  enclosingCharacter={""}
                  className="btn btn-primary test"
                  target="_blank"
                >
                  Export CSV
                </CSVLink>
              </Button>

              <DataTable
                style={{ overflow: "hidden" }}
                filter
                pagination
                highlightOnHover
                columns={columns}
                data={newSuggestionList}
                expandableRows
                expandableRowsComponent={ExpandableRow}
                expandableRowExpanded={(row) => row.s_status == 0}
                progressPending={isLoading}
                progressComponent={<CustomLoader />}
              />
            </>
          </Card>
        </Container>

        {/* Suggestion Answer Modal */}
        <Modal
          open={answerModal}
          onClose={() => {
            setAnswerModal(false);
            setFiles([]);
          }}
        >
          <Box sx={askDetailModalStyle}>
            <Box
              sx={{
                overflowY: "auto",
                flex: 1,
                p: 1,
                mt: 1
              }}
            >
              <Typography variant="h6" textAlign="center">
                Suggestion Answer
              </Typography>
              <TextField
                label="Enter Answer"
                fullWidth
                multiline
                rows={10}
                value={suggestionAnswer}
                onChange={(e) => setSuggestionAnswer(e.target.value)}
                style={{ marginTop: "10px" }}
              />

              <RadioGroup
                style={{ marginTop: "0px", flexWrap: "nowrap" }}
                row
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
                name="s_status"
              >
                <FormControlLabel value="0" control={<Radio />} label="Open Suggestion" />
                <FormControlLabel value="1" control={<Radio />} label="Close Suggestion" />
              </RadioGroup>

              <Box
                component="label"
                sx={{
                  width: "100%",
                  height: 70,
                  border: "2px dashed #d1d5db",
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                  cursor: "pointer",
                  bgcolor: "#fafafa",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    bgcolor: "#f1f5f9",
                    borderColor: "#6366f1"
                  }
                }}
              >
                <input
                  type="file"
                  hidden
                  multiple
                  accept={allowedTypes.join(",")}
                  onChange={(e) => handleFiles(e.target.files)}
                />

                <CloudUploadIcon sx={{ color: "#6b7280" }} />

                <Typography variant="body2" fontWeight={500}>
                  Upload Files
                </Typography>
              </Box>

              {files.map((file, index) => {
                const isImage = file.type.startsWith("image/");
                const isVideo = file.type.startsWith("video/");
                const isPdf = file.type === "application/pdf";

                return (
                  <Box
                    key={index}
                    sx={{
                      mt: 1,
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      border: "1px solid #e0e0e0",
                      borderRadius: 2,
                      p: 1,
                      bgcolor: "#fafafa"
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {isImage ? (
                        <img
                          src={URL.createObjectURL(file)}
                          alt=""
                          width={40}
                          height={40}
                          style={{ borderRadius: 6, objectFit: "cover" }}
                        />
                      ) : isVideo ? (
                        <video width={40} height={40} style={{ borderRadius: 6 }}>
                          <source src={URL.createObjectURL(file)} />
                        </video>
                      ) : (
                        <PictureAsPdfIcon color="error" />
                      )}
                    </Box>

                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Typography
                        variant="body2"
                        sx={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis"
                        }}
                      >
                        {file.name}
                      </Typography>

                      <Typography variant="caption" color="text.secondary">
                        {(file.size / 1024 / 1024).toFixed(2)} MB
                      </Typography>
                    </Box>

                    <Box>
                      <Button
                        size="small"
                        onClick={() => window.open(URL.createObjectURL(file), "_blank")}
                      >
                        <VisibilityIcon fontSize="small" />
                      </Button>

                      <Button
                        size="small"
                        color="error"
                        onClick={() => setFiles((prev) => prev.filter((_, i) => i !== index))}
                      >
                        <CloseIcon fontSize="small" />
                      </Button>
                    </Box>
                  </Box>
                );
              })}

              <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
                <Button
                  variant="contained"
                  className="btn btn-primary"
                  onClick={suggestionAnswerHandler}
                  disabled={isAttachmentSubmitLoading}
                  startIcon={
                    isAttachmentSubmitLoading && <CircularProgress size={20} color="inherit" />
                  }
                >
                  Submit
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setAnswerModal(false);
                    setSuggestionAnswer("");
                    setFiles([]);
                  }}
                >
                  Cancel
                </Button>
              </Stack>
            </Box>
          </Box>
        </Modal>

        {/* Attachments Modal */}
        <Modal open={attachmentsModal} onClose={() => setAttachmentsModal(false)}>
          <Box sx={askDetailModalStyle}>
            <Box
              sx={{
                overflowY: "auto",
                flex: 1,
                p: 1,
                mt: 1,
                height: 400,
                minHeight: 400
              }}
            >
              <Typography variant="h6" textAlign="center">
                {attachmentsType == 1 ? "Suggestion Attachments" : "Suggestion Answer Attachments"}
              </Typography>

              {suggestionID?.[
                attachmentsType == 1
                  ? "suggestion_attachments"
                  : attachmentsType == 2
                    ? "suggestion_ans_attachments"
                    : ""
              ]?.length > 0 ? (
                suggestionID?.[
                  attachmentsType == 1
                    ? "suggestion_attachments"
                    : attachmentsType == 2
                      ? "suggestion_ans_attachments"
                      : ""
                ]?.map((file, index) => {
                  const fileUrl = `${Routes.API_HOSTNAME}suggestion-attachments/${file?.url}`;

                  const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(file?.url);
                  const isVideo = /\.(mp4|webm|ogg)$/i.test(file?.url);
                  const isPdf = /\.pdf$/i.test(file?.url);

                  return (
                    <Box
                      key={index}
                      sx={{
                        mt: 1,
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        border: "1px solid #e0e0e0",
                        borderRadius: 2,
                        p: 1,
                        bgcolor: "#fafafa"
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        {isImage ? (
                          <img
                            src={fileUrl}
                            alt=""
                            width={40}
                            height={40}
                            style={{ borderRadius: 6, objectFit: "cover" }}
                          />
                        ) : isVideo ? (
                          <video width={40} height={40} style={{ borderRadius: 6 }}>
                            <source src={fileUrl} />
                          </video>
                        ) : isPdf ? (
                          <PictureAsPdfIcon color="error" />
                        ) : (
                          <InsertDriveFileIcon />
                        )}
                      </Box>

                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography
                          variant="body2"
                          sx={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                          }}
                        >
                          {file?.url}
                        </Typography>
                      </Box>

                      <Box sx={{ display: "flex", gap: 1 }}>
                        <IconButton
                          size="small"
                          onClick={() => {
                            window.open(fileUrl, "_blank");
                          }}
                        >
                          <VisibilityIcon fontSize="small" />
                        </IconButton>

                        <IconButton
                          size="small"
                          onClick={() => {
                            handleDownload(fileUrl, file?.url);
                          }}
                        >
                          <DownloadIcon fontSize="small" />
                        </IconButton>

                        {attachmentsType == 2 && (
                          <IconButton
                            size="small"
                            color="error"
                            onClick={() => setDvisible({ mval: true, id: file?.s_a_id })}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        )}
                      </Box>
                    </Box>
                  );
                })
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 400
                  }}
                >
                  <Typography color="text.secondary">There are no attachments</Typography>
                </Box>
              )}
            </Box>
          </Box>
        </Modal>
      </Page>
    </>
  );
}
